import React,{ useState } from 'react'
import MapGL, {GeolocateControl } from 'react-map-gl'
import 'mapbox-gl/dist/mapbox-gl.css'



/*<Marker
      coordinates={[-0.2416815, 51.5285582]}
      anchor="bottom">
      <img src={"https://img.icons8.com/office/16/000000/marker.png"}/>
      </Marker>
*/

const geolocateStyle = {
  float: 'left',
  margin: '20px',
  padding: '10px'
};

const Map = () => {

  const [viewport, setViewPort ] = useState({
    width: "100%",
    height: 700,
    latitude: 41.6611,
    longitude: -91.5302,
    zoom: 12,
  })
  
// <marker></marker>
  const _onViewportChange = viewport => setViewPort({...viewport})
  
  

  return (
    <div style={{ margin: '0 auto'}}>
    
      <MapGL
        {...viewport}
        mapboxApiAccessToken={'pk.eyJ1IjoiamFzb25nLWlzdSIsImEiOiJjazFvMjYyODAwaHUxM2RyeXNvcG1qNXlvIn0.9jmaNirbBevmEUI4OAvarQ'}
        mapStyle="mapbox://styles/jasong-isu/ck1oatw371h771cnld98slsld"
        onViewportChange={_onViewportChange}
      >
      
        <GeolocateControl
          style={geolocateStyle}
          positionOptions={{enableHighAccuracy: true}}
          trackUserLocation={true}
        />
      </MapGL>
    </div>
  )
  }

export default Map;

/*

var geojson = {
  type: 'FeatureCollection',
  features: [{
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-77.032, 38.913]
    },
    properties: {
      title: 'Mapbox',
      description: 'Washington, D.C.'
    }
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-122.414, 37.776]
    },
    properties: {
      title: 'Mapbox',
      description: 'San Francisco, California'
    }
  }]
};


// add markers to map
geojson.features.forEach(function(marker) {

  // create a HTML element for each feature
  var el = document.createElement('div');
  el.className = 'marker';

  // make a marker for each feature and add to the map
  new mapboxgl.Marker(el)
    .setLngLat(marker.geometry.coordinates)
    .addTo(Map);
});

*/

/*
    Map.addLayer({
      "id": "points",
      "type": "symbol",
      "source": {
        "type": "geojson",
        "data": {
        "type": "FeatureCollection",
        "features": [{
          "type": "Feature",
          "geometry": {
            "type": "Point",
            "coordinates": [-77.03238901390978, 38.913188059745586]
            }
          }, {
          "type": "Feature",
          "geometry": {
            "type": "Point",
            "coordinates": [-122.414, 37.776]
          }
        }]
        }
      }
    });
*/